import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

import { logger } from '@assess/shared/logger';
import { Nullable } from '@assess/shared/type-utilities';

import { getControl } from '../functions/get-control';

/**
 * Locates a FormControl from the dynamic context based on the provided configuration path.
 */
@Pipe({ name: 'formControlResolver' })
export class FormControlResolverPipe implements PipeTransform {
  transform(control: Nullable<AbstractControl>, controlPath: string): FormControl {
    const resolved = getControl(control, controlPath);

    if (!resolved) {
      logger.warn({ context: FormControlResolverPipe.name, data: { controlPath } }, 'Control could not be resolved');
    }

    return resolved as any;
  }
}
